<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Setting </strong><small>Edit Data</small>
          </CCardHeader>
          <CCardBody>
            <CForm @submit.prevent="updateSetting">
            <CRow>
              <CCol sm="12">
              <div class="form-group">
                <label>About</label>
                <VueEditor
                  v-model="about"
                  placeholder="Input About"
                  :editorToolbar="customToolbar"
                ></VueEditor>
              </div>
              </CCol>
              <CCol sm="12">
              <div class="form-group">
                <label>Footer</label>
                <VueEditor
                  v-model="footer"
                  placeholder="Input Footer"
                  :editorToolbar="customToolbar"
                ></VueEditor>
              </div>
              </CCol>
              <CCol sm="12">
              <div class="form-group">
                <label>Address</label>
                <VueEditor
                  v-model="address"
                  placeholder="Input Address"
                  :editorToolbar="customToolbar"
                ></VueEditor>
              </div>
              </CCol>
              <CCol sm="6">
              <CInput
                v-model="phone"
                label="Phone"
                placeholder="Input Phone"
              />
              </CCol>
              <CCol sm="6">
              <CInput
                v-model="fax"
                label="Fax"
                placeholder="Input Fax"
              />
              </CCol>
              <CCol sm="6">
              <CInput
                v-model="email"
                label="Email"
                placeholder="Input Email"
              />
              </CCol>
              <CCol sm="6">
              <CInput
                v-model="title"
                label="Title"
                placeholder="Input Title"
              />
              </CCol>
              <CCol sm="12">
              <div class="form-group">
                <label>Redaksi</label>
                <VueEditor
                  v-model="redaksi"
                  placeholder="Input Redaksi"
                  :editorToolbar="customToolbar"
                ></VueEditor>
              </div>
              </CCol>
              <CCol sm="12">
              <div class="form-group">
                <label>Popular Tag</label>
                <VueEditor
                  v-model="populartag"
                  placeholder="Input Popular Tag"
                  :editorToolbar="customToolbar"
                ></VueEditor>
              </div>
              </CCol>
              <CCol sm="12">
              <div class="form-group">
                <label>Privacy</label>
                <VueEditor
                  v-model="privacy"
                  placeholder="Input Privacy"
                  :editorToolbar="customToolbar"
                ></VueEditor>
              </div>
              </CCol>
              <CCol sm="12">
              <div class="form-group">
                <label>Sitemap</label>
                <VueEditor
                  v-model="sitemap"
                  placeholder="Input Sitemap"
                  :editorToolbar="customToolbar"
                ></VueEditor>
              </div>
              </CCol>
              <CCol sm="12">
              <div class="form-group">
                <label>Email Body</label>
                <VueEditor
                  v-model="email_body"
                  placeholder="Input Email Body"
                  :editorToolbar="customToolbar"
                ></VueEditor>
              </div>
              </CCol>
            </CRow>            

                <div class="form-actions">
                  <CButton type="submit" color="primary" style='margin-right:15px'>Simpan</CButton>
                  <CButton color="secondary" to="/profil">Batal</CButton>
                </div>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Error Input"
      color="danger"
      id="modalError"
    >
      <b>Error</b>! Data Profil gagal diinput.
    </CModal>
   
  </div>    
  
</template>

<script>
import axios from 'axios';
import * as Modals from '../notifications/Modals.vue'
import { VueEditor } from "vue2-editor";

export default {
  name: 'Forms',
  components: {
    VueEditor
  },
  computed : {
    years () {
      const year = new Date().getFullYear()
      return Array.from({length: year - 2019}, (value, index) => new Date().getFullYear() - index)
    }
  },
  data () {
    return {
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ['image', 'code-block']
      ],
      logo: "",
      default_img: "",
      about: "",
      footer: "",
      address: "",
      phone: "",
      redaksi: "",
      populartag: "",
      fax: "",
      email: "",
      title: "",
      privacy: "",
      sitemap: "",
      email_body: "",
      selected: [],
      show: true,
      horizontal: { label:'col-3', input:'col-9' },
      options: ['Option 1', 'Option 2', 'Option 3'],
      jenis: ['Penyelenggaran Jalan Kabupaten/Kota'],
      subjenis: ['Pembangunan dan Peningkatan Jalan', 'Rekonstruksi / Pemeliharaan / Rehabilitasi Jalan', 'Pembangunan Jembatan / Box Culvert'],
      tahuns: ['2021','2020'],
      selectOptions: [
        'Option 1', 'Option 2', 'Option 3',
        { 
          value: 'some value', 
          label: 'Selected option'
        }
      ],
      selectedOption: 'some value',
      formCollapsed: true,
      checkboxNames: ['Checkboxes', 'Inline Checkboxes',
                      'Checkboxes - custom', 'Inline Checkboxes - custom'],
      radioNames: ['Radios', 'Inline Radios',
                    'Radios - custom', 'Inline Radios - custom']
    }
  },
  mounted(){
    this.showProfil();
  },
  methods: {
    updateSetting: function(event){
      const setting = { 
        logo: this.logo,
        default_img: this.default_img,
        about: this.about,
        footer: this.footer,
        address: this.address,
        phone: this.phone,
        redaksi: this.redaksi,
        populartag: this.populartag,
        fax: this.fax,
        email: this.email,
        title: this.title,
        privacy: this.privacy,
        sitemap: this.sitemap,
        email_body: this.email_body,
        id: this.$route.params.id_profil,
      };
      
      axios.post(process.env.VUE_APP_BASE_URL+'/setting/update', setting)
        .then((response) => {
            if(response.status==200){
              this.$router.push('/setting');
            }
            else{
              this.myError = true;
            }
        })
    },
    showProfil: function(event){
      axios.get(process.env.VUE_APP_BASE_URL+'setting/'+this.$route.params.id_setting)
        .then((response) => {
            this.logo = response.data.logo;
            this.default_img = response.data.default_img;
            this.about = response.data.about;
            this.footer = response.data.footer;
            this.address = response.data.address;
            this.phone = response.data.phone;
            this.redaksi = response.data.redaksi;
            this.populartag = response.data.populartag;
            this.fax = response.data.fax;
            this.email = response.data.email;
            this.title = response.data.title;
            this.privacy = response.data.privacy;
            this.sitemap = response.data.sitemap;
            this.email_body = response.data.email_body;
        })
    }
  }
}
</script>